<template>
  <div class="flex main-div">
    <div v-if="!uiFlags.isFetching" class="flex draggable-view">
      <!-- Render each draggable list dynamically -->
      <!-- Hi I am Draggablkfjdkjfkd-->
      <draggable
        v-model="localStatusData"
        class="lists-group"
        group="lists"
        :move="checkDrag"
        :filter="filterNonDraggable"
        :fallbackOnBody="false"
        :forceFallback="true"
        :scroll="true"
        @start="onDragStart"
        @move="onDragMove"
        @change="onListsChange"
      >
        <div
          v-for="(list, statusIndex) in localStatusData"
          :key="list.id"
          ref="draggableArea"
          class="pipeline-main"
          :class="{ minimized: list.minimize, 'main-minimized': list.minimize }"
          :data-status-index="statusIndex"
        >
          <div
            class="new-lead pipeline-lead"
            :class="{ minimized: list.minimize }"
            :data-status-index="statusIndex"
          >
            <div
              class="new-lead-data lead-data"
              :style="{ backgroundColor: list.color }"
              :class="{
                minimized: list.minimize,
                'cursor-grab': list.dragable,
              }"
              :data-status-index="statusIndex"
            >
              <div
                v-if="!list.minimize"
                class="new-lead-body"
                :data-status-index="statusIndex"
              >
                {{ list.name }}
                <fluent-icon
                  v-if="metaConversionEventForStatus(list.name)"
                  v-tooltip.right="
                    $t('PIPELINES.META_CONVERSION_INFO_TOOLTIP', {
                      event: metaConversionEventForStatus(list.name),
                    })
                  "
                  icon="info"
                  size="14"
                  class="meta-conversion-info-icon"
                  :data-status-index="statusIndex"
                />
                <span
                  v-if="list.items.length > 0"
                  :data-status-index="statusIndex"
                  >({{ pipelineColumnLoadedDisplay(list) }}/{{ list.total_count }})</span
                >
              </div>
              <div
                class="new-lead-icon"
                :class="{ minimized: list.minimize }"
                ref="dropdowns"
                :data-status-index="statusIndex"
              >
                <div
                  v-if="!list.minimize"
                  class="edit-lead"
                  :data-status-index="statusIndex"
                >
                  <woot-button
                    v-if="list.modify"
                    :data-status-index="statusIndex"
                    v-tooltip="$t('PIPELINES.EDIT_PIPELINE')"
                    title="$t('PIPELINES.EDIT_PIPELINE')"
                    icon="edit"
                    variant="smooth"
                    size="small"
                    :disabled="uiFlags.isUpdating"
                    @click="editStatus(list.id)"
                    class="action-button black-icon"
                  />
                </div>
                <div
                  v-if="!list.minimize"
                  class="delete-lead"
                  :data-status-index="statusIndex"
                >
                  <woot-button
                    v-if="list.modify"
                    :data-status-index="statusIndex"
                    v-tooltip="$t('PIPELINES.DELETE_PIPELINE')"
                    title="$t('PIPELINES.DELETE_PIPELINE')"
                    icon="delete"
                    variant="smooth"
                    size="small"
                    :disabled="uiFlags.isDeleting"
                    @click="toggleDeleteModal(list.id, list.name)"
                    class="action-button black-icon"
                  />
                </div>

                <div v-if="list.minimize" :data-status-index="statusIndex">
                  <input
                    type="checkbox"
                    :data-status-index="statusIndex"
                    v-model="list.minimize"
                    @change="minimizeDiv(statusIndex)"
                    class="input-checkbox cursor-pointer"
                    :class="{ 'minimize-input': list.minimize }"
                  />
                </div>
                <div
                  class="dropdown-container-data"
                  :data-status-index="statusIndex"
                >
                  <woot-button
                    v-if="!list.minimize"
                    v-tooltip="'More Action'"
                    icon="more-vertical"
                    class="clear secondary rtl:rotate-180 width-none clear-hover bold-icon"
                    @click="
                      toggleDropdown(statusIndex, list);
                      $event.stopPropagation();
                    "
                    :data-status-index="statusIndex"
                  />
                  <div
                    v-if="list.show_options"
                    class="bg-black-50 dark:bg-slate-800 dropdown-menu set-width"
                    :data-status-index="statusIndex"
                    style="z-index: 1;"
                  >
                    <label
                      class="flex cursor-pointer"
                      :data-status-index="statusIndex"
                    >
                      <input
                        type="checkbox"
                        v-model="list.dragable"
                        @change="handleCheckboxChange(statusIndex)"
                        class="input-checkbox"
                        :data-status-index="statusIndex"
                      />
                      {{ $t('PIPELINES.DRAGGABLE') }}
                    </label>
                    <label
                      class="flex cursor-pointer"
                      :data-status-index="statusIndex"
                    >
                      <input
                        type="checkbox"
                        v-model="list.minimize"
                        @change="minimizeDiv(statusIndex)"
                        class="input-checkbox"
                        :data-status-index="statusIndex"
                      />
                      {{ $t('PIPELINES.MINIMIZE') }}
                    </label>
                    <label
                    v-if="isActionsFiltersFeatureEnabled &&  currentUser?.role == 'administrator'"
                      class="flex cursor-pointer text-nowrap"
                      :data-status-index="statusIndex"
                    >
                      <input
                        type="checkbox"
                        v-model="list.agent_dragable"
                        @change="agentDragableDiv(statusIndex)"
                        class="input-checkbox"
                        :data-status-index="statusIndex"
                      />
                      {{ $t('PIPELINES.AGENT_DRAGGABLE') }}
                    </label>
                    <div v-if="isAgentBotsFeatureEnabled">
                      <label
                        class="flex cursor-pointer"
                        :data-status-index="statusIndex"
                      >
                        <input
                          type="checkbox"
                          v-model="list.allow_payment"
                          @change="handleAllowPaymentChange(statusIndex,list.allow_payment)"
                          class="input-checkbox"
                          :data-status-index="statusIndex"
                        />
                        {{ $t('PIPELINES.ALLOW_PAYMENT') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="!uiFlags.isFetchingContacts && !list.minimize"
            class="scrolling-draggable"
            ref="scrollableArea"
            :data-pipeline-list-scroll="list.id"
            :data-status-index="statusIndex"
            @scroll="onScroll(list.id, list)"
          >
            <div
              class="flex justify-center"
              :data-status-index="statusIndex"
              v-if="list.items.length == 0"
            >
              {{ $t('PIPELINES.NO_CONTACTS') }}
            </div>
            <draggable
              class="dragArea list-group"
              :list="list.items"
              :data-status-index="statusIndex"
              :group="{ name: 'people', pull: pullFunction }"
              @start="onCardDragStart"
              :ghost-class="'drag-placeholder'"
              :fallbackOnBody="false"
              :forceFallback="true"
              :scroll="true"
              :delay="120"
              :touch-start-threshold="6"
              :fallbackTolerance="6"
              @change="onItemDragged($event, list.id, list)"
            >
              <div
                class="bg-white dark:bg-slate-900 list-group-item cursor-grab"
                :class="{ 'highlight-selected': highlight === element.id }"
                v-for="element in list.items"
                :key="element.id"
                @click.stop="openContactInfoPanel(element)"
              >
                <div class="flex row items-center gap-1 flex-wrap">
                  <div
                    class="left-column name flex flex-1 min-w-0 items-center gap-0.5"
                    v-tooltip="element?.name?.length > 15 ? element.name : ''"
                  >
                    <span class="truncate min-w-0">{{
                      element?.name?.length > 15
                        ? element?.name.slice(0, 15) + '...'
                        : element?.name
                    }}</span>
                    <lead-quality-crown
                      v-if="accountId"
                      :account-id="accountId"
                      :metadata="element.lead_quality_metadata"
                    />
                    <lead-response-watch
                      :waiting-since-unix="element.response_wait_waiting_since"
                      class="flex-shrink-0"
                    />
                  </div>
                  <div
                    class="state-name"
                    :style="getStateStyle(element)"
                    v-tooltip.bottom-end="element.state_name && element.state_name.length > 5 ? element.state_name : ''"
                  >
                    {{ formatStateName(element.state_name) }}
                  </div>
                </div>
                <div class="contact-info flex">
                  <div class="date-img">
                    <div class="last-contacted">Last Contacted</div>
                    <div class="left-column date-color">
                      {{ formatDate(element.last_updated_at) }}
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <contact-label-pipeline
                    :contact-id="element.id"
                    :initial-labels="element.labels"
                    :popup="isModalOpen"
                    :selected-contact-id="highlight"
                    class="contact-labels pt-2"
                  />
                  <div class="ml-auto right-column">
                        <!-- <fluent-icon
                        v-if="hasCalendarReminder(element)"
                        icon="clock"
                        viewBox="0 0 13 16"
                        class="h-[22px] w-[25px] bg-transparent text-black-900"
                        :class="{
                            'redClassName': isCalendarInFuture(element)
                              }"
                        /> -->
                    <thumbnailPipeline
                      v-if="pipelineCardHasAssignee(element)"
                      v-tooltip.top-end="element.assignee_name"
                      :src="element.assignee_image"
                      class="user-thumbnail-pipeline"
                      :variant="'circle'"
                      :title="element.assignee_name"
                      :username="element.assignee_name"
                      height="35px"
                      width="40px"
                    />
                    <div
                      v-else
                      v-tooltip.top-end="$t('PIPELINES.NO_ASSIGNEE')"
                      class="pipeline-board-unassigned-assignee flex shrink-0 items-center justify-center"
                      role="img"
                      :aria-label="$t('PIPELINES.NO_ASSIGNEE')"
                    >
                      <div
                        class="pipeline-board-unassigned-assignee__circle flex shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400"
                      >
                        <fluent-icon icon="person" size="14" class="shrink-0" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex items-center w-full max-w-xs justify-between" v-if="hasCalendarReminder(element)">
                <span class="truncate whitespace-nowrap text-[13px] overflow-hidden flex-shrink max-w-[60%] textColor">
                  Reminder
                </span>

                <div class="ml-auto flex items-center space-x-2 flex-shrink-0">
                  <fluent-icon
                    icon="clock"
                    viewBox="0 0 13 16"
                    class="h-[22px] w-[25px] bg-transparent text-black-900 textColor"
                    :class="{ 'redClassName': isCalendarInFuture(element) }"
                  />
                  <p class="mt-[6px] text-[11px] textColor tracking-normal"
                  :class="{ 'redClassName': isCalendarInFuture(element) 
                  }">
                    {{ formatDatee(element?.additional_attributes?.calendar_timings) }}
                  </p>
                </div>
            </div>




              </div>
              <div class="loading-data">
                <loading-state
                  v-if="uiFlags.islazyloading && loadingListId === list.id"
                  class="no-padding"
                />
              </div>
            </draggable>
          </div>
          <div
            class="bg-white dark:bg-slate-900 text-dark story-points"
            v-if="list.minimize"
            :data-status-index="statusIndex"
          >
            {{ list.name }}
          </div>
          <div v-else-if="uiFlags.isFetchingContacts">
            <loading-state
              v-if="uiFlags.isFetchingContacts"
              :message="emptyContactMessage"
            />
          </div>
        </div>
      </draggable>

      <!-- Button to add a new list -->
      <div class="col-3 add-plus">
        <woot-button
          :icon="'add'"
          v-tooltip.left="$t('PIPELINES.CREATE_PIPELINE')"
          title="$t('PIPELINES.CREATE_PIPELINE')"
          @click="showForm"
          class="create-button"
        />
      </div>
      <edit-status-modal
        :show="toggleEditModal"
        @close="toggleEditState"
        :getModaldata="editdata || {}"
      />
      <create-status-modal
        :show="toggleCreateModal"
        :lists="list"
        @close="toggleCreateState"
      />
      <!-- Displaying raw data of lists for debugging purposes -->
      <!-- <rawDisplayer class="col-3" :value="lists[0].items" title="List 1" />
      <rawDisplayer class="col-3" :value="lists[1].items" title="List 2" /> -->
    </div>
    <div v-else class="loading-container">
      <loading-state v-if="uiFlags.isFetching" :message="emptyStateMessage" />
    </div>
    <div>
      <woot-delete-modal
        v-if="showDeleteModal"
        :show.sync="showDeleteModal"
        :on-close="closeDelete"
        :on-confirm="confirmDeletion"
        :title="$t('DELETE_CONTACT.CONFIRM.TITLE')"
        :message="$t('DELETE_CONTACT.CONFIRM.MESSAGE')"
        :message-value="confirmDeleteMessage"
        :confirm-text="$t('DELETE_CONTACT.CONFIRM.YES')"
        :reject-text="$t('DELETE_CONTACT.CONFIRM.NO')"
      />
    </div>
    <div v-if="showErrorDiv" class="error-div">
      <button class="close-icon" @click="closeErrorDiv">✖</button>
      {{ errorMessage }}
    </div>
    <div
      v-if="isModalOpen"
      class="modal-overlay-v1"
      @click="closeModalPanel"
    ></div>
    <contact-info-panel
      v-if="selectedContact"
      :contact="selectedContact"
      :on-close="closeModal"
      :pipeline-contact="true"
      :is-modal-view="true"
      @contact-deleted="handleContactDeleted"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import alertMixin from 'shared/mixins/alertMixin';
import EditStatusModal from './EditStatusModal.vue';
import CreateStatusModal from './CreateStatusModal.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import { mapGetters } from 'vuex';
import ThumbnailPipeline from '../../../../components/widgets/ThumbnailPipeline.vue';
import LeadResponseWatch from 'dashboard/components/widgets/LeadResponseWatch.vue';
import ContactInfoPanel from '../../contacts/components/ContactInfoPanel.vue';
import ContactLabelPipeline from 'dashboard/routes/dashboard/contacts/components/ContactLabelPipeline.vue';
import LeadQualityCrown from 'dashboard/components/LeadQualityCrown.vue';
import { FEATURE_FLAGS } from '../../../../featureFlags';

/** Keep in sync with `per_page` in Api::V1::Accounts::PipelinesController#index */
const PIPELINE_LAZY_PER_PAGE = 15;



export default {
  name: 'clone-on-control',
  components: {
    draggable,
    EditStatusModal,
    CreateStatusModal,
    LoadingState,
    ThumbnailPipeline,
    LeadResponseWatch,
    ContactInfoPanel,
    ContactLabelPipeline,
    LeadQualityCrown,
  },
  mixins: [alertMixin],
  props: {
    currentassignee: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedContactId: null,
      contactToDelete: null, // holds the ID of the status to delete
      showDeleteModal: false,
      name: '',
      description: '',
      color: '',
      draggable: false,
      response: '',
      list: null,
      // Default lists with their initial items and colors
      controlOnStart: true,
      toggleEditModal: false,
      toggleCreateModal: false,
      editdata: {},
      emptyStateMessage: 'Loading State',
      emptyContactMessage: 'Loading Contacts',
      draggingItem: null,
      oldListId: null,
      localStatusData: [], // Initialize with an empty array or fetch data
      sourceList: null,
      draggedElement: null,
      currentpage: 2,
      nodata: true,
      currentlistId: null,
      pageNo: 1,
      isDropdownOpen: false,
      isMinimized: false,
      src: 'data:image/jpeg;base64,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',
      deleteStatusName: '',
      showErrorDiv: false,
      errorMessage: '',
      selectedContact: null,
      selectedContactId: '',
      isModalOpen: false,
      loadingListId: null,
      highlight: null,
      activeFetchListIds: new Set(),
      scrollThrottleUntil: {},
      scrollThrottleMs: 400,
      newStatus: {},
      isUpdating: false,
    };
  },
  watch: {
    statusData: {
      immediate: true,
      handler(newVal) {
        this.localStatusData = newVal;
        this.list = newVal.length;
        console.log('My Local Data', this.localStatusData);
        this.$emit('contact-count-updated', this.totalContactsCount);
      },
    },
    $route(to, from) {
      if (to.name === 'pipeline_custom_view') {
        return;
      }
      if (to.params.board_id !== from.params.board_id) {
        // Board data loading is handled in Index.vue to keep board-scoped
        // filter restoration and avoid race conditions with full-data reloads.
        return;
      }
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      getContact: 'contacts/getContact',
      boards: 'pipelines/getAllBoards',
    }),
    statusData() {
      // console.log(
      //   'My Status Data',
      //   this.$store.getters['pipelines/getAllState']
      // );
      this.list = this.$store.getters['pipelines/getAllState'].length;
      return this.$store.getters['pipelines/getAllState'];
    },
    confirmDeleteMessage() {
      return ` ${this.deleteStatusName}?`;
    },
    showContactViewPane() {
      return this.selectedContactId !== '';
    },
    wrapClass() {
      return this.showContactViewPane ? 'w-[75%]' : 'w-full';
    },
    totalContactsCount() {
      return this.localStatusData.reduce((total, list) => {
        return total + (Number(list.total_count) || 0);
      }, 0);
    },
    isAgentBotsFeatureEnabled() {
    return this.isFeatureEnabledonAccount(
      this.accountId,
      FEATURE_FLAGS.PAYMENT_DASHBOARD
    );
  },

  isActionsFiltersFeatureEnabled() {
     console.log(
        'Checking if actions filters is enabled for account new pipeline',
        this.accountId,this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.ACTIONS_FILTERS
        )
      );

      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.ACTIONS_FILTERS
      );
    },
    isMetaConversionFeatureEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.META_CONVERSION_BOARD_SYNC
      );
    },
    currentBoardForMetaConversion() {
      const rawId =
        this.$route.params.board_id ||
        this.$route.params.boardId ||
        null;
      const boardId = rawId ? Number(rawId) : null;
      if (!boardId || !Array.isArray(this.boards)) return null;
      return this.boards.find(board => Number(board.id) === boardId) || null;
    },
  },
  mounted() {
    // this.$store.dispatch('pipelines/getContact');
    bus.$on('reloaad-pipeline', this.getStatuswithoutContact);
    bus.$on('reload-contact-updated', this.handleContactUpdated);
    bus.$on(
      'pipeline-contact-board-changed',
      this.handleContactBoardChanged
    );
    document.addEventListener('click', this.handleClickOutside);
    // this.getStatus();
    console.log('Local Status Data', this.localStatusData);
    bus.$on('toggle-pipeline-dropdown', this.toggleDropdownpipeline);
  },
  beforeDestroy() {
    bus.$off('reloaad-pipeline', this.getStatuswithoutContact);
    bus.$off('reload-contact-updated', this.handleContactUpdated);
    bus.$off(
      'pipeline-contact-board-changed',
      this.handleContactBoardChanged
    );
    bus.$off('toggle-pipeline-dropdown', this.toggleDropdownpipeline);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    metaConversionEventForStatus(statusName) {
      if (!this.isMetaConversionFeatureEnabled) return null;
      const board = this.currentBoardForMetaConversion;
      if (!board || !board.meta_conversion_enabled) return null;
      const mappings = Array.isArray(board.meta_conversion_stage_mappings)
        ? board.meta_conversion_stage_mappings
        : [];
      const name = (statusName || '').toString();
      if (!name) return null;
      const match = mappings.find(mapping => {
        if (!mapping || typeof mapping !== 'object') return false;
        const pipelineStage = (
          mapping.pipeline_stage ||
          mapping['pipeline_stage'] ||
          ''
        ).toString();
        const metaStage = (
          mapping.meta_stage ||
          mapping['meta_stage'] ||
          ''
        ).toString();
        return pipelineStage && metaStage && pipelineStage === name;
      });
      return match ? match.meta_stage || match['meta_stage'] : null;
    },
    handleMouseDown(event, contact) {
      this.clickStartTime = Date.now();
    },
      formatDatee(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  },
       shouldHighlightCalendar(element) {
            const timing = element?.additional_attributes?.calendar_timing;
            if (!timing) return false;

            const calendarTime = new Date(timing);
            const now = new Date();
           console.log(element.name, "this is the checl condition,", calendarTime, now)
           console.log(calendarTime> now)
            return calendarTime > now;
          },
            hasCalendarReminder(element) {
            return !!element?.additional_attributes?.calendar_timings;
          },
          isCalendarInFuture(element) {

            const raw = element?.additional_attributes?.calendar_timings;
              if (!raw) return false;

              let sanitized = raw.replace(/,/g, ''); 

              sanitized = sanitized.replace(/(\d{1,2}:\d{1,2}):(\d{1})(\s[AP]M)/, '$1:0$2$3');
              sanitized = sanitized.replace(/(\d{1,2}:\d{1,2}):(\d{2})(\s[AP]M)/, '$1:$2$3');

              const calendarTime = new Date(sanitized);
              const now = new Date();

              if (isNaN(calendarTime.getTime())) {
                console.warn('Invalid date format after sanitization:', sanitized);
                return false;
              }

              // console.log("Parsed:", calendarTime.toString(), "Now:", now.toString());
              // console.log("this is the result", calendarTime > now)
              return calendarTime < now;

        },
    handleMouseUp(event, contact) {
      // If less than 200ms passed, it's a click not a drag
      if (Date.now() - this.clickStartTime < 200 && !this.isDragging) {
        this.selectedContactId = contact.id;
        this.openContactInfoPanel(contact);
      }
      this.isDragging = false;
    },

    onCardDragStart(evt) {
      this.isDragging = true;
      if (evt && evt.originalEvent) {
        this.controlOnStart = evt.originalEvent.ctrlKey;
      }
    },
    pipelineCardHasAssignee(element) {
      if (!element) return false;
      const id = element.assignee_id;
      return id !== null && id !== undefined && id !== '';
    },
    minimizeDiv(statusIndex) {
      const list = this.localStatusData[statusIndex];
      list.show_options = false;
    },
  async  agentDragableDiv(statusIndex) {
      const list = this.localStatusData[statusIndex];

      const response = await axios.patch(
        `/api/v1/accounts/${this.accountId}/statuses/${list.id}/update_agent_dragable`, 
        {
          agent_dragable: list.agent_dragable, 
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'api-access-token': this.currentUser.access_token,
          },
        }
      );
    },
    toggleDropdown(statusIndex, list) {
      // Close all other dropdowns
      this.localStatusData.forEach((item, index) => {
        if (index !== statusIndex) {
          item.show_options = false; // Close dropdowns for other lists
        }
      });

      // Toggle dropdown visibility for the clicked item
      bus.$emit('toggle-pipeline-dropdown-dragging');
      list.show_options = !list.show_options;

      // If opening dropdown, ensure the checkbox is correctly reflecting the draggable state
      if (list.show_options) {
        this.$nextTick(() => {
          // Optionally, you could log or perform any additional checks here
          // console.log(
          //   `Dropdown opened for: ${list.name}, Draggable: ${list.isDraggable}`
          // );
        });
      }
    },
    handleCheckboxChange(index) {
      const list = this.localStatusData[index];
      // Close dropdown when checkbox changes
      console.log('My index', index, list);
      list.show_options = false;
      // this.isAllListsDisabled(index);
    },
    handleClickOutside(event) {
      const dropdowns = this.$refs.dropdowns;
      dropdowns.forEach(dropdown => {
        const statusIndex = dropdown.dataset.statusIndex;
        if (dropdown && dropdown.contains(event.target)) {
          return; // Click is inside this dropdown, do nothing
        } else {
          this.closeDropdown(statusIndex); // Click is outside, close the dropdown
        }
      });
    },
    closeDropdown(statusIndex) {
      // this.isDropdownOpen = !this.isDropdownOpen; // Toggle visibility
      this.localStatusData[statusIndex].show_options = false;
    },
    checkDrag(evt) {
      // Prevent dragging if the item is not draggable
      // return this.localStatusData[evt.draggedContext.index].dragable;
      this.localStatusData.forEach(list => {
        list.show_options = false;
      });
      const draggedItemIndex = evt.draggedContext.index;
      if (!this.localStatusData[draggedItemIndex].dragable) {
        return false; // Stop the drag operation
      }
      return true; // Allow dragging
    },
    addNewList() {
      this.showForm = true;
    },
    async getStatus() {
      const boardId = this.$route.params.board_id;
      // Single refresh after create/delete — do not also dispatch FilterContact
      // (it shares the fetch generation and previously left isFetching stuck).
      await this.$store.dispatch('pipelines/getStatus', { board_id: boardId });
    },

    confirmDeletion() {
      const id = this.contactToDelete;
      const board_id = this.$route.params.board_id;
      this.deleteStatus(id, board_id); // Store the ID of the status to delete
      this.closeDelete();
    },
    toggleDeleteModal(id, name) {
      this.closeAll();
      this.contactToDelete = id;
      this.deleteStatusName = name;
      this.showDeleteModal = !this.showDeleteModal;
    },
    async deleteStatus(status_id, board_id) {
      console.log('Hello', status_id, board_id);
      const boardId = this.$route.params.board_id;
      this.closeAll();
      const data = {
        board_id: board_id,
        status_id: status_id,
      };
      const response = await this.$store.dispatch(
        'pipelines/deleteStatus',
        data
      );

      // Log the alert message
      // console.log('Alert Message:', response.data.message);
      // console.log('success Message:', response.data.success);
      this.getStatus();
      if (response.data.success) {
        this.showAlert(response.data.message, {
          success: response.data.success,
        });
      } else {
        this.errorMessage = response.data.message;
        this.showErrorDiv = true;
      }
      bus.$emit('dropdown-data', true);
      bus.$emit('reset-date-dropdown');
      if (boardId != undefined) {
        console.log('My Board Id', boardId);
        bus.$emit('dropdown-boardId', boardId);
      }
    },
    closeErrorDiv() {
      this.showErrorDiv = false;
      this.errorMessage = '';
    },
    closeDelete() {
      this.showDeleteModal = false;
    },
    async editStatus(status_id) {
      const boardId = this.$route.params.board_id;
      this.closeAll();
      const board_id = this.$route.params.board_id;
      console.log('My Edit id', status_id);
      const data = {
        board_id: board_id,
        status_id: status_id,
      };
      const response = await this.$store.dispatch(
        'pipelines/getStatusdata',
        data
      );
      // console.log('response', response);
      const { data: status_data } = response;
      // console.log('Status Dta', status_data);
      this.editdata = status_data.status_data || {};
      // console.log('editdata::::', this.editdata);
      // this.showSuccessMessage = true;
      this.toggleEditModal = true;
      if (boardId != undefined) {
        console.log('My Board Id', boardId);
        bus.$emit('dropdown-boardId', boardId);
      }
      // this.getStatus();
      // this.showAlert(response.data.message, { success: response.data.success });
      // bus.$emit('reset-date-dropdown');
    },
    clone(list, element) {
      const data = {
        index: list.index,
        contact_id: element.id,
      };
      this.$store.dispatch('pipelines/DragcontactUpdate', data);
      return {
        ...element, // Keep all properties of the element
        listId: list.id, // Add list information if needed
      };
    },

    pullFunction() {
      return this.controlOnStart ? 'clone' : true;
    },
    async onListsChange(evt) {
      const response = await this.$store.dispatch(
        'pipelines/DragstatusUpdate',
        {
          oldindex: evt.moved.oldIndex,
          index: evt.moved.newIndex,
          status_id: evt.moved.element.id,
          boardId: this.$route.params.board_id,
        }
      );
      this.showAlert(response.data.message, { success: response.data.success });
    },
    // async onItemDragged(event, destinationListId, list, statusIndex) {
    //   let response;
    //   try {
    //     // console.log("Event",event);
    //     if (event.moved) {
    //       const new_index = event.moved.newIndex;
    //       const contact_id = event.moved.element.id;
    //       // console.log(
    //       //   'Destination list ID:',
    //       //   destinationListId,
    //       //   list,
    //       //   this.localStatusData,
    //       //   statusIndex
    //       // );
    //       const data = {
    //         new_index: new_index,
    //         contact_id: contact_id,
    //         status_id: list.id,
    //       };
    //       console.log('My Contact Params', data);
    //       response = await this.$store.dispatch(
    //         'pipelines/DragcontactUpdate',
    //         data
    //       );
    //     } else if (event.added) {
    //       // console.log('Event Added:::', event.added);
    //       const new_index = event.added.newIndex;
    //       const contact_id = event.added.element.id;
    //       // console.log(
    //       //   'Destination list ID:',
    //       //   destinationListId,
    //       //   list,
    //       //   this.localStatusData,
    //       //   statusIndex
    //       // );
    //       const data = {
    //         new_index: new_index,
    //         contact_id: contact_id,
    //         status_id: list.id,
    //       };
    //       console.log('My Contact Params', data);
    //       response = await this.$store.dispatch(
    //         'pipelines/DragcontactUpdate',
    //         data
    //       );
    //     }
    //     if (response && response.data) {
    //       this.showAlert(response.data.message, {
    //         success: response.data.success,
    //       });
    //     } else {
    //       // this.showAlert('An unexpected error occurred.');
    //     }
    //   } catch (error) {
    //     console.error('Error in onItemDragged:', error);
    //     this.showAlert('Failed to update contact. Please try again.');
    //   }
    // },
    async onItemDragged(event, statusListId, list) {
      // Apply optimistic counter deltas FIRST so rapid consecutive moves remain
      // consistent (each event independently adjusts its own column by ±1).
      // Source decrement uses the column id that fired `removed` (statusListId),
      // not contact.status_id which may already have been updated by `added`.
      let appliedDelta = null;
      if (event.removed) {
        this.adjustColumnTotalCount(statusListId, -1);
        appliedDelta = { listId: statusListId, delta: -1 };
        this.emitTotalCountUpdate();

        // For a cross-column drag, vuedraggable fires `@change` twice: once
        // with `event.removed` on the source list (this branch, which has no
        // `contact_id` derivable from `event.moved/added` and returns early),
        // and once with `event.added` on the destination list (which performs
        // the API call). Stash the source-leg state so the destination leg can
        // roll back BOTH counters and the DOM if the server rejects the move.
        const removedContact = event.removed && event.removed.element;
        if (removedContact && removedContact.id != null) {
          if (!this._pendingMoveCleanup) {
            this._pendingMoveCleanup = new Map();
          }
          this._pendingMoveCleanup.set(Number(removedContact.id), {
            sourceListId: statusListId,
            sourceOldIndex:
              event.removed.oldIndex != null ? event.removed.oldIndex : 0,
            // Keep a reference to the contact so we can reinsert into source
            // even if the destination row has been removed by another flow
            // before our rollback runs.
            contact: removedContact,
          });
        }

        // If the source column still shows fewer than a full "page" of cards but
        // the server has more rows (`total_count` > loaded), the stored `page`
        // cursor can be ahead of what the UI still holds (e.g. was at page 2,
        // user dragged out until only 4 cards remain). The next scroll would
        // then request page 3 and skip page 2. Reset to refetch from page 1;
        // merge dedupes by contact id.
        const sourceList = this.localStatusData.find(
          l => Number(l.id) === Number(statusListId)
        );
        if (sourceList) {
          const totalC = Number(sourceList.total_count) || 0;
          const itemC = sourceList.items.length;
          if (totalC > itemC && itemC < PIPELINE_LAZY_PER_PAGE) {
            this.$set(sourceList, 'page', 0);
            this.$set(sourceList, 'contactpresent', true);
          }
        }
        this.schedulePipelineScrollFillCheck(statusListId);
      } else if (event.added) {
        this.adjustColumnTotalCount(list.id, +1);
        appliedDelta = { listId: list.id, delta: +1 };
        this.emitTotalCountUpdate();
        // Same stale cursor issue on the destination when dropping into a column
        // that only has a short visible stack but more contacts exist server-side.
        const totalC = Number(list.total_count) || 0;
        const itemC = list.items.length;
        if (totalC > itemC && itemC < PIPELINE_LAZY_PER_PAGE) {
          this.$set(list, 'page', 0);
          this.$set(list, 'contactpresent', true);
        }
        this.schedulePipelineScrollFillCheck(list.id);
      }

      const rawContactId =
        event?.moved?.element?.id || event?.added?.element?.id || null;

      if (rawContactId == null) return;

      // Normalize id once to avoid string/number mismatches with `item.id`
      // coming back from different code paths (server payload, vuedraggable).
      const contact_id = Number(rawContactId);
      if (!Number.isFinite(contact_id)) return;

      let originalStatusId =
        event?.moved?.element?.status_id ||
        event?.added?.element?.status_id ||
        null;
      if (!originalStatusId) {
        const contact = list.items.find(
          item => Number(item.id) === contact_id
        );
        originalStatusId = contact ? contact.status_id : null;
      }

      if (!originalStatusId) return;

      try {
        // Wait for DOM & reactive data to fully update
        await this.$nextTick();

        const new_index = list.items.findIndex(
          item => Number(item.id) === contact_id
        );

        const data = {
          new_index: new_index,
          contact_id: contact_id,
          status_id: list.id,
          boardId: this.$route.params.board_id,
        };
        // vuedraggable contract: `event.moved` fires only for in-place reorder
        // within the same column. `event.added` fires on the destination of a
        // cross-column drop. So a defined `oldIndex` here means same-column.
        const old_index = event?.moved?.oldIndex;
        const isSameColumnReorder = old_index !== undefined;

        // True no-op: same column AND position unchanged.
        if (isSameColumnReorder && old_index === new_index) {
          return;
        }

        // `agent_dragable=false` is meant to block agents from moving contacts
        // *into* this pipeline status. For same-column reorders the status
        // doesn't change, so this guard must not run there (it would revert the
        // card to the top of its own column).
        if (
          !isSameColumnReorder &&
          list.agent_dragable == false &&
          this.currentUser.role == 'agent'
        ) {
          this.revertContactToOriginalStatus(
            contact_id,
            originalStatusId,
            list,
            event
          );
          // Roll back optimistic delta because revert restores items but does
          // its own counter adjustment for the source/dest swap.
          if (appliedDelta) {
            this.adjustColumnTotalCount(
              appliedDelta.listId,
              -appliedDelta.delta
            );
            this.emitTotalCountUpdate();
          }
          // Revert already moved the contact back to source and bumped the
          // source counter, so the source-leg cleanup is no longer needed.
          this.discardPendingMoveCleanup(contact_id);
          return;
        }

        const updatedList = list.items.find(
          ele => Number(ele.id) === contact_id
        );
        if (updatedList) {
          updatedList.status_id = statusListId;
        }

        const response = await this.$store.dispatch(
          'pipelines/DragcontactUpdate',
          data
        );

        const ok = response && response.data && response.data.success !== false;
        if (!ok) {
          // Server rejected: roll back the optimistic delta on this leg, AND
          // (for cross-column moves) restore the source counter and move the
          // contact DOM-wise back to its original column.
          if (appliedDelta) {
            this.adjustColumnTotalCount(
              appliedDelta.listId,
              -appliedDelta.delta
            );
            this.emitTotalCountUpdate();
          }
          this.rollbackPendingMoveCleanup(contact_id, list);
        } else {
          // Re-sync column totals from the server so optimistic ±1 counters and
          // lazy-load pagination cannot drift from DB truth (fixes footer vs refresh).
          let statusIdsToRefresh = [];
          if (isSameColumnReorder) {
            statusIdsToRefresh = [Number(list.id)].filter(Number.isFinite);
          } else {
            const pending = this._pendingMoveCleanup?.get(contact_id);
            const src = pending?.sourceListId;
            const dst = Number(list.id);
            if (Number.isFinite(src) && Number.isFinite(dst)) {
              statusIdsToRefresh =
                src === dst ? [dst] : [src, dst];
            } else if (Number.isFinite(dst)) {
              statusIdsToRefresh = [dst];
            }
          }
          const boardId = this.$route.params.board_id;
          if (boardId && statusIdsToRefresh.length) {
            await this.$store.dispatch(
              'pipelines/refreshPipelineColumnTotalsFromServer',
              {
                statusIds: statusIdsToRefresh,
                boardId,
                administratorAssigneeId: this.currentassignee || null,
              }
            );
            this.emitTotalCountUpdate();
          }
          // Success: source-leg cleanup is no longer needed for this contact.
          this.discardPendingMoveCleanup(contact_id);
          if (response && response.data && response.data.message) {
            this.showAlert(response.data.message, {
              success: response.data.success,
            });
          }
        }
      } catch (error) {
        console.error(' Error in onItemDragged:', error);
        if (appliedDelta) {
          this.adjustColumnTotalCount(
            appliedDelta.listId,
            -appliedDelta.delta
          );
          this.emitTotalCountUpdate();
        }
        this.rollbackPendingMoveCleanup(contact_id, list);
        this.showAlert('Failed to update contact. Please try again.');
      }
    },

revertContactToOriginalStatus(contact_id, originalStatusId, list, event) {


  const originalIndex = list.items.findIndex(
    item => Number(item.id) === Number(contact_id)
  );

  if (originalIndex !== -1) {
    console.log("Found contact at original index:", originalIndex);

    const contact = list.items[originalIndex];
    console.log("Contact ------:", contact);
    contact.status_id = originalStatusId;

    this.$set(list.items, originalIndex, contact); 

    const originalList = this.localStatusData.find((list) => list.id === originalStatusId);

    if (originalList) {
      const movedItem = list.items.splice(originalIndex, 1)[0]; 
      originalList.items.unshift(movedItem); 
      originalList.total_count = Math.max(0, originalList.total_count + 1);
    }

    this.$set(this.localStatusData, this.localStatusData.indexOf(originalList), originalList);
    this.$set(list, 'items', [...list.items]); 

    this.showAlert('Agent is not allowed to move this contact here.', {success: false});
  } else {
    console.log("Contact not found in the list");
  }
},

    /**
     * Roll back a pending source-leg cleanup for a cross-column drag whose
     * destination-leg server call has failed. Restores both the source counter
     * and the contact's DOM position. Safe to call when no pending entry
     * exists (no-op).
     */
    rollbackPendingMoveCleanup(contactId, destinationList) {
      if (!this._pendingMoveCleanup) return;
      const key = Number(contactId);
      const pending = this._pendingMoveCleanup.get(key);
      if (!pending) return;

      // 1) Try to recover the actual contact object: either still in the
      //    destination column (vuedraggable mutated it there on drop) or, if
      //    something else has already removed it, fall back to the reference
      //    stashed on the source leg.
      let movedItem = null;
      if (destinationList) {
        const destIdx = destinationList.items.findIndex(
          item => Number(item.id) === key
        );
        if (destIdx !== -1) {
          movedItem = destinationList.items.splice(destIdx, 1)[0];
        }
      }
      if (!movedItem) movedItem = pending.contact || null;

      // 2) Locate the source column. If it's gone (board switched, hidden, etc.)
      //    we cannot safely reinsert; bail out without touching counters so we
      //    don't introduce a phantom +1 when nothing is restored visually.
      const sourceList = this.localStatusData.find(
        l => Number(l.id) === Number(pending.sourceListId)
      );

      if (sourceList && movedItem) {
        const alreadyThere = sourceList.items.some(
          it => Number(it.id) === key
        );
        if (!alreadyThere) {
          movedItem.status_id = pending.sourceListId;
          const insertIdx = Math.min(
            Math.max(0, Number(pending.sourceOldIndex) || 0),
            sourceList.items.length
          );
          sourceList.items.splice(insertIdx, 0, movedItem);
        }
        // Restore the source counter only when the row is back on screen, so
        // counter and items.length stay in agreement.
        this.adjustColumnTotalCount(pending.sourceListId, +1);
        this.emitTotalCountUpdate();
      }

      this._pendingMoveCleanup.delete(key);
    },
    /** Drop the source-leg cleanup entry without rolling anything back. */
    discardPendingMoveCleanup(contactId) {
      if (!this._pendingMoveCleanup) return;
      this._pendingMoveCleanup.delete(Number(contactId));
    },
    pipelineColumnDistinctLoaded(list) {
      const items = list?.items;
      if (!Array.isArray(items) || items.length === 0) return 0;
      return new Set(
        items.map(i => Number(i?.id)).filter(Number.isFinite)
      ).size;
    },
    /** Header count: distinct loaded, capped by server total (avoids 42/40). */
    pipelineColumnLoadedDisplay(list) {
      const distinct = this.pipelineColumnDistinctLoaded(list);
      const t = Number(list.total_count);
      if (Number.isFinite(t) && t >= 0) {
        return Math.min(distinct, t);
      }
      return distinct;
    },
    adjustColumnTotalCount(statusId, delta) {
      const target = this.localStatusData.find(
        l => Number(l.id) === Number(statusId)
      );
      if (!target) return;
      const current = Number(target.total_count);
      const safe = Number.isFinite(current) ? current : 0;
      this.$set(target, 'total_count', Math.max(0, safe + delta));
    },
    emitTotalCountUpdate() {
      this.$nextTick(() => {
        this.$emit('contact-count-updated', this.totalContactsCount);
      });
    },

    toggleEditState() {
      this.toggleEditModal = false;
    },
    showForm() {
      this.toggleCreateModal = true;
    },
    toggleCreateState() {
      this.toggleCreateModal = false;
    },
    formatDate(dateString) {
      if (!dateString) return 'No Conversation';

      const date = new Date(dateString);
      const today = new Date();

      const isToday =
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();

      if (isToday) {
        return 'Today';
      }

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const dayOfWeek = daysOfWeek[date.getDay()];

      return `${month}/${day}/${year}, ${dayOfWeek}`;
    },
    // async onScroll(listId, list, statusIndex) {
    //   const scrollableArea = this.$refs.scrollableArea[statusIndex];
    //   console.log("ScrollableArea.scrollTop",scrollableArea.scrollTop);
    //   console.log("ScrollableArea.clientHeight",scrollableArea.clientHeight);
    //   console.log("ScrollableArea.scrollHeight",scrollableArea.scrollHeight);
    //   console.log("Add Data",scrollableArea.scrollTop + scrollableArea.clientHeight);
    //   console.log("heloo scroll", scrollableArea.scrollTop + scrollableArea.clientHeight >=
    //   scrollableArea.scrollHeight)
    //   if (
    //     scrollableArea.scrollTop + scrollableArea.clientHeight >=
    //     scrollableArea.scrollHeight
    //   ) {
    //     // console.log('Hello', listId, list);
    //     // Call the API to fetch more items
    //   }
    //   await this.fetchMoreItems(listId, list);
    // },
    // async onScroll(listId, list, statusIndex) {
    //   const scrollableArea = this.$refs.scrollableArea[statusIndex];

    //   if (!scrollableArea) return;

    //   // Tolerance for scroll detection to prevent minor pixel mismatches
    //   const threshold = 10;

    //   const scrollPosition =
    //     scrollableArea.scrollTop + scrollableArea.clientHeight;
    //   const scrollHeight = scrollableArea.scrollHeight;
    //   // console.log("Scroll scrollTop",scrollableArea.scrollTop);
    //   // console.log("Scroll clientHeight",scrollableArea.clientHeight);
    //   // console.log("Scroll scrollHeight",scrollableArea.scrollHeight);
    //   // console.log("Scroll Position",scrollPosition);
    //   // console.log('Condition', scrollHeight - scrollPosition <= threshold);
    //   // Check if scrolled to the bottom
    //   // console.log("My List",list,list.total_count,list.items.length);

    //   if ((scrollHeight - scrollPosition <= threshold)&&(!list.total_count || list.items.length < list.total_count)) {
    //     console.log('Reached the bottom, fetching more items...');
    //     this.loadingListId = list.id;
    //     await this.fetchMoreItems(listId, list);
    //   }
    // },
    getScrollableElForListId(listId) {
      const root = this.$el;
      if (!root || typeof root.querySelector !== 'function') return null;
      return root.querySelector(
        `[data-pipeline-list-scroll="${String(listId)}"]`
      );
    },
    /**
     * After drag-drop or store updates, the column can sit at the visual "bottom"
     * with no scrollbar movement, so `@scroll` never fires. Re-run the same
     * near-bottom check once layout has settled (rAF after nextTick).
     */
    schedulePipelineScrollFillCheck(listId) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const list = this.localStatusData.find(
            l => Number(l.id) === Number(listId)
          );
          const scrollableArea = this.getScrollableElForListId(listId);
          if (!list || !scrollableArea) return;
          this.attemptPipelineFetchIfNearBottom(listId, list, scrollableArea, {
            bypassThrottle: true,
          });
        });
      });
    },
    attemptPipelineFetchIfNearBottom(
      listId,
      list,
      scrollableArea,
      { bypassThrottle = false } = {}
    ) {
      if (!scrollableArea) return;

      const threshold = 80;
      const scrollPosition =
        scrollableArea.scrollTop + scrollableArea.clientHeight;
      const scrollHeight = scrollableArea.scrollHeight;

      const isAtBottom = scrollHeight - scrollPosition <= threshold;
      const hasMoreItems =
        list.total_count != null &&
        this.pipelineColumnDistinctLoaded(list) < list.total_count;
      const isAlreadyFetching = this.activeFetchListIds.has(list.id);
      const now = Date.now();
      const lastCheck = this.scrollThrottleUntil[listId] || 0;
      const throttleOk =
        bypassThrottle || now - lastCheck >= this.scrollThrottleMs;

      if (
        isAtBottom &&
        hasMoreItems &&
        !isAlreadyFetching &&
        throttleOk
      ) {
        this.scrollThrottleUntil[listId] = now;
        this.activeFetchListIds.add(list.id);
        this.loadingListId = list.id;

        this.fetchMoreItems(listId, list)
          .catch(err => console.error('Pipeline fetch more:', err))
          .finally(() => {
            this.activeFetchListIds.delete(list.id);
            if (this.loadingListId === list.id) {
              this.loadingListId = null;
            }
          });
      }
    },
    onScroll(listId, list) {
      const scrollableArea = this.getScrollableElForListId(listId);
      if (!scrollableArea) return;
      this.attemptPipelineFetchIfNearBottom(listId, list, scrollableArea, {
        bypassThrottle: false,
      });
    },
    async fetchMoreItems(listId, list, chainDepth = 0) {
      const MAX_PIPELINE_LAZY_CHAIN = 40;
      console.log('My List id', listId, list);

      let loadSucceeded = false;

      // Ensure `list.contactpresent` is defined and true
      if (list.contactpresent === undefined || list.contactpresent) {
        // page === 0 is a sentinel meaning "the column was drained, refetch
        // page 1 next". Otherwise, advance from the last fetched page; if the
        // page is undefined, default to 2 (initial load already gave page 1).
        let pageNo;
        if (list.page === 0) {
          pageNo = 1;
        } else {
          pageNo = list.page ? list.page + 1 : 2;
        }

        console.log('Fetching Page No:', pageNo);

        const data = {
          key: 'status_id',
          value: listId,
          key6: 'page',
          value6: pageNo,
        };
        const boardId = this.$route.params.board_id;

        // Conditionally add board_id to data object
        if (boardId) {
          data.key4 = 'board_id';
          data.value4 = boardId;
        }


      if(this.currentUser.role === "administrator"){
        // console.log("this os jdknfadnf", this.currentassignee)
            if(this.currentassignee){
            data.key1 = "assignee_id";
            data.value1 = this.currentassignee;
            }
        }else{
          data.key1 = "assignee_id";
          data.value1 = this.currentUser.id;
        }
        console.log('My Final Data', data);

        try {
          const response = await this.$store.dispatch(
            'pipelines/Lazyloading',
            data
          );

          const success = response?.data?.success;
          if (success) {
            list.page = pageNo;
            loadSucceeded = true;
          } else if (!success && response) {
            console.error('Failed to fetch data:', response?.data);
          }
        } catch (error) {
          console.error('Error during API call:', error);
        }
      }

      // Chain further pages inside this same async call so the outer
      // `.finally()` on `fetchMoreItems` only runs after the full fill chain
      // completes (avoids overlapping lazy loads for the same column).
      if (
        loadSucceeded &&
        chainDepth < MAX_PIPELINE_LAZY_CHAIN
      ) {
        await this.$nextTick();
        const freshList =
          this.localStatusData.find(l => Number(l.id) === Number(listId)) ||
          list;
        const scrollEl = this.getScrollableElForListId(listId);
        if (scrollEl) {
          const threshold = 80;
          const scrollPosition =
            scrollEl.scrollTop + scrollEl.clientHeight;
          const scrollHeight = scrollEl.scrollHeight;
          const isAtBottom =
            scrollHeight - scrollPosition <= threshold;
          const hasMoreItems =
            freshList.total_count != null &&
            this.pipelineColumnDistinctLoaded(freshList) <
              freshList.total_count;
          if (isAtBottom && hasMoreItems) {
            await this.fetchMoreItems(listId, freshList, chainDepth + 1);
          }
        }
      }
    },
    filterNonDraggable(evt) {
      const targetElement = evt.target; // Get the target DOM element
      if (targetElement && targetElement.classList) {
        const statusIndex = targetElement.dataset.statusIndex;
        // Check if statusIndex is valid and ensure the corresponding item exists in localStatusData
        if (
          statusIndex &&
          this.localStatusData[statusIndex]?.dragable !== undefined
        ) {
          return !this.localStatusData[statusIndex].dragable;
        }
      }
      return false;
    },
    onDragStart(evt) {
      const container = document.querySelector('.lists-group');
      this.containerRect = container.getBoundingClientRect(); // Store container bounds
    },
    onDragMove(evt) {
      if (!evt.originalEvent || !this.containerRect) return;

      const ghostElement = document.querySelector('.sortable-fallback'); // The ghost class
      const { clientX, clientY } = evt.originalEvent; // Current mouse position

      // Constrain the ghost element to the container bounds
      const left = Math.max(
        this.containerRect.left,
        Math.min(clientX, this.containerRect.right - ghostElement.offsetWidth)
      );
      const top = Math.max(
        this.containerRect.top,
        Math.min(clientY, this.containerRect.bottom - ghostElement.offsetHeight)
      );

      // Update the position of the ghost element
      ghostElement.style.left = `${left}px`;
      ghostElement.style.top = `${top}px`;
    },
    toggleDropdownpipeline() {
      this.closeAll();
    },
    closeAll() {
      // Close all other dropdowns
      this.localStatusData.forEach((item, index) => {
        item.show_options = false; // Close dropdowns for other lists
      });
    },
    formatStateName(name) {
      if (!name) return 'None';
      return name.length > 10 ? name.slice(0, 3) + '...' : name;
    },
    getStateStyle(el) {
      const bgColor =
        el.state_color && el.state_color.bg ? el.state_color.bg : '#FFEFEF';
      const textColor =
        el.state_color && el.state_color.text ? el.state_color.text : '#FF0000';
      return {
        backgroundColor: bgColor,
        color: textColor,
      };
    },
    openContactInfoPanel(contact) {
      if (contact) {
        const epochTime = new Date(contact.created_at).getTime();
        const epochTimeInSeconds = Math.floor(epochTime / 1000);
        this.selectedContact = {
          ...contact,
          created_at: epochTimeInSeconds,
        };
        // console.log("selectcontact after creating date",this.selectedContact);
        this.isModalOpen = true;
        this.highlight = contact.id;
      }
    },
    handleContactUpdated() {
      // Sync selectedContact and board cards with updated contact from Vuex
      const contactId = this.selectedContact?.id;
      if (!contactId) return;

      const vuexContact = this.getContact(contactId);
      if (!vuexContact?.id) return;

      // Update selectedContact so the modal reflects the change
      this.selectedContact = { ...this.selectedContact, ...vuexContact };

      // Update the contact in localStatusData so the board card reflects the change
      this.localStatusData.forEach(list => {
        const contactIndex = list.items?.findIndex(item => item.id === contactId);
        if (contactIndex !== undefined && contactIndex >= 0) {
          this.$set(list.items, contactIndex, { ...list.items[contactIndex], ...vuexContact });
        }
      });
    },
    handleContactBoardChanged({ contactId, boardId } = {}) {
      if (!contactId) return;

      const routeBoardId = this.$route.params.board_id
        ? Number(this.$route.params.board_id)
        : null;
      if (!routeBoardId) return;

      const contactBoardId =
        boardId != null && boardId !== '' ? Number(boardId) : null;
      const contactLeftCurrentBoard =
        contactBoardId == null || contactBoardId !== routeBoardId;

      if (!contactLeftCurrentBoard) return;

      this.localStatusData.forEach(list => {
        if (!Array.isArray(list.items)) return;
        const contactIndex = list.items.findIndex(item => item.id === contactId);
        if (contactIndex >= 0) {
          list.items.splice(contactIndex, 1);
          if (list.total_count != null) {
            list.total_count = Math.max(0, Number(list.total_count) - 1);
          }
        }
      });

      if (this.selectedContact?.id === contactId) {
        const vuexContact = this.getContact(contactId);
        if (vuexContact?.id) {
          this.selectedContact = { ...this.selectedContact, ...vuexContact };
        }
      }

      this.$emit('contact-count-updated', this.totalContactsCount);
    },
    closeModalPanel() {
      this.isModalOpen = false;
      this.selectedContact = null;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedContact = null;
    },
    getStatuswithoutContact() {
      if (this.$route.name === 'pipeline_custom_view') {
        return;
      }
      let board_id = this.$route.params.board_id
        ? Number(this.$route.params.board_id)
        : null;
      this.$store.dispatch('pipelines/getStatus', { board_id: board_id });
    },
    async updateAllowPayment(index,value) {
      console.log("My Index",index,value);
      try {
        this.isUpdating = true;
        const list = this.localStatusData[index];
        this.newStatus = {
        ...this.newStatus,
        allow_payment: value, // Add/Update allow_payment field
      };
      console.log('My updated Data', this.newStatus,list);
        const response = await axios.put(
          `/api/v1/accounts/${this.accountId}/statuses/${list.id}`,
          this.newStatus,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token,
            },
          }
        );
        console.log('My Response', response);
        // const index = this.statuses.findIndex(
        //   status => status.id === this.newStatus.id
        // );
        // this.$set(this.statuses, index, { ...this.newStatus });
        // this.showForm = false;
        this.showAlert(response.data.message, {
          success: response.data.success,
        });
        // this.fetchStatuses(board_id);
        // bus.$emit('dropdown-boardId', board_id)
        // this.resetForm();
      } catch (error) {
        console.error('Error updating status:', error);
      } finally {
        this.isUpdating = false;
      }
    },
    handleAllowPaymentChange(index,value) {
      console.log("My Index",index,value);
      this.updateAllowPayment(index,value);
    },
    handleContactDeleted() {
      this.closeModal();
      this.getStatuswithoutContact();
    },
  },
};
</script> 

<style scoped>
.highlight-selected {
  background-color: #f3f9ff !important;
  border-left: 3px solid #1f93ff !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.create-button {
  background-color: #efefef;
  color: #000;
  height: 45px;
  width: 55px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.width-none {
  width: auto !important;
  /* color: #aaaaaa !important; */
}
.clear-hover {
  background-color: transparent !important;
  box-shadow: none !important;
}
.dark .clear-hover{
  color: black !important;
}
.clear-hover:hover {
  background-color: transparent !important;
  box-shadow: none !important;
}
.action-button {
  background: none !important;
  width: auto !important;
}
.contact-info {
  margin-top: 15px;
}
.last-contacted {
  color: #aaa;
  font-size: 12px;
}
.state-name {
  font-size: x-small;
  text-align: center;
  border-radius: 5px;
  margin-right: 15px;
  padding-left: 4px;
  padding-right: 4px;
}
.black-icon {
  color: #413f3f;
}
.dark .black-icon{
  color: #000;
}
.modal-overlay-v1 {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 39;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}
.set-width {
  width: fit-content;
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1;
}
.dark .loading-container {
  background-color: rgba(0, 0, 0, 0.9);
}
.loading-container-relative {
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.redClassName{
  color: red !important;;
}
.textColor{
  color: #706969;
}
</style>
